
(() => {
  if (window.STNativeDrinkModifiersLoaded) return;
  window.STNativeDrinkModifiersLoaded = true;

  const normalize = (value) => String(value || '').replace(/\s+/g, ' ').trim().toLowerCase();
  const money = (value) => '$' + Number(value).toFixed(2);

  const chargeVariantByPrice = new Map([
    ['0.35', '49023574605895'],
    ['0.50', '49023574638663'],
    ['0.65', '49023574671431'],
    ['0.95', '49023574704199'],
    ['1.00', '49023574736967'],
    ['0.15', '49871266250823'],
    ['0.25', '49871266283591'],
    ['1.25', '49023574769735'],
    ['1.50', '49871266316359']
  ]);

  const defs = new Map();
  // ST Modifiers storefront bridge: read public metaobjects rendered by Liquid at page load.
  // The imported fields are the editable source of prices; hard-coded prices below are fallback only.
  function mergeAppPrices() {
    const source = document.querySelector('[data-st-app-price-source]');
    if (!source) return;
    let payload;
    try { payload = JSON.parse(source.textContent || '{}'); }
    catch (_) { return; }
    if (!Array.isArray(payload.fields)) return;

    // The Coffee Modifiers import calls this field "Coffee Type", while the site calls it "Coffee Roast".
    const fieldAliases = new Map([['coffee type', 'coffee roast']]);
    const definitions = [...new Set(defs.values())];
    for (const field of payload.fields) {
      if (!field || !Array.isArray(field.choices)) continue;
      const original = normalize(field.name);
      const name = fieldAliases.get(original) || original;
      // Only override a matching modifier field; never match a choice label across unrelated fields.
      for (const def of definitions) {
        if (normalize(def.label) !== name || !Array.isArray(def.options)) continue;
        for (const option of def.options) {
          const saved = field.choices.find(choice => normalize(choice.label) === normalize(option.value)
            || normalize(choice.label) === normalize(option.label));
          if (!saved || saved.price === null || saved.price === undefined || saved.price === '') continue;
          const amount = Number(saved.price);
          if (Number.isFinite(amount) && amount >= 0) option.price = Math.round(amount * 100) / 100;
        }
      }
    }
    if (Array.isArray(payload.chargeVariants)) {
      for (const v of payload.chargeVariants) {
        const amount = Number(v.price);
        if (Number.isFinite(amount) && amount >= 0 && v.id) {
          chargeVariantByPrice.set(amount.toFixed(2), String(v.id));
        }
      }
    }
  }


  const addDef = (names, def) => {
    for (const name of names) defs.set(normalize(name), def);
  };

  addDef(
    ['Extra Tea Bag'],
    {
      key: 'extra_tea_bag',
      label: 'Extra Tea Bag',
      type: 'multi_qty',
      required: false,
      options: [{ value: 'Tea Bag', label: 'Tea Bag', price: 1.50, max: 6 }]
    }
  );

  addDef(
    ['Additional Espresso Shots - ZJ23FLQADUCJ6LYEZHWHIY2B'],
    {
      key: 'extra_espresso',
      label: 'Extra Espresso',
      type: 'multi_qty',
      required: false,
      options: [{ value: '1 Shot', label: '1 Shot', price: 1.25, max: 6 }]
    }
  );

  addDef(
    ['Additional Espresso Shots - QEJICJ2BCPUEY463XFBQPP62'],
    {
      key: 'extra_espresso_shots',
      label: 'Extra Espresso Shots',
      type: 'multi_qty',
      required: false,
      options: [{ value: 'Espresso', label: 'Espresso', price: 1.25, max: 6 }]
    }
  );

  addDef(
    ['Additional Add on Sauce'],
    {
      key: 'extra_sauce',
      label: 'Extra Sauce',
      type: 'multi_qty',
      required: false,
      options: [
        { value: 'Caramel Sauce', label: 'Caramel Sauce', price: 1.25, max: 6 },
        { value: 'Chocolate Sauce', label: 'Chocolate Sauce', price: 1.25, max: 6 },
        { value: 'White Chocolate Sauce', label: 'White Chocolate Sauce', price: 1.25, max: 6 }
      ]
    }
  );

  addDef(
    ['Additional Add on Syrups'],
    {
      key: 'extra_syrup',
      label: 'Extra Syrup',
      type: 'multi_qty',
      required: false,
      options: [
        { value: 'French Vanilla', label: 'French Vanilla', price: 1.00, max: 6 },
        { value: 'Hazelnut', label: 'Hazelnut', price: 1.00, max: 6 },
        { value: 'Almond', label: 'Almond', price: 1.00, max: 6 },
        { value: 'Salted Caramel', label: 'Salted Caramel', price: 1.00, max: 6 },
        { value: 'Lavender', label: 'Lavender', price: 1.00, max: 6 },
        { value: 'Raspberry', label: 'Raspberry', price: 1.00, max: 6 },
        { value: 'Organic Honey', label: 'Organic Honey', price: 1.50, max: 2 }
      ]
    }
  );

  addDef(
    ['Included  Syrup Selection'],
    {
      key: 'included_syrup',
      label: 'Syrup Flavor',
      type: 'single',
      required: true,
      options: [
        { value: 'French Vanilla', label: 'French Vanilla', price: 0 },
        { value: 'Hazelnut', label: 'Hazelnut', price: 0 },
        { value: 'Almond', label: 'Almond', price: 0 },
        { value: 'Salted Caramel', label: 'Salted Caramel', price: 0 },
        { value: 'Lavender', label: 'Lavender', price: 0 },
        { value: 'Raspberry', label: 'Raspberry', price: 0 }
      ]
    }
  );

  addDef(
    ['Coffee'],
    {
      key: 'coffee_type',
      label: 'Coffee Roast',
      type: 'single',
      required: true,
      defaultValue: 'Regular Roast',
      options: [
        { value: 'Regular Roast', label: 'Regular Roast', price: 0 },
        { value: 'Decaf', label: 'Decaf', price: 0.35 }
      ]
    }
  );

  addDef(
    ['Extra Sauce Drizzle'],
    {
      key: 'extra_drizzle',
      label: 'Extra Drink Drizzle',
      type: 'single',
      required: false,
      defaultValue: 'None',
      options: [
        { value: 'None', label: 'No Extra Drizzle', price: 0, omitProperty: true },
        { value: 'Chocolate Drizzle', label: 'Chocolate Drizzle', price: 0.65 },
        { value: 'Caramel Drizzle', label: 'Caramel Drizzle', price: 0.65 },
        { value: 'White Chocolate Drizzle', label: 'White Chocolate Drizzle', price: 0.65 },
        { value: 'Biscoff Cookie Butter', label: 'Biscoff Cookie Butter', price: 0.95 }
      ]
    }
  );

  addDef(
    ['Extras Whip/Cold Foam'],
    {
      key: 'extras_whip_cold_foam',
      label: 'Whip & Cold Foam',
      type: 'compound',
      required: false,
      children: [
        {
          key: 'whip',
          label: 'Whip',
          type: 'single',
          required: false,
          defaultValue: 'No Whip',
          options: [
            { value: 'No Whip', label: 'No Whip', price: 0, omitProperty: true },
            { value: 'Whip', label: 'Whip', price: 0.35 }
          ]
        },
        {
          key: 'cold_foam',
          label: 'Cold Foam',
          type: 'single',
          required: false,
          defaultValue: 'No Cold Foam',
          options: [
            { value: 'No Cold Foam', label: 'No Cold Foam', price: 0, omitProperty: true },
            { value: 'Vanilla Cold Foam', label: 'Vanilla Cold Foam', price: 0.50 },
            { value: 'White Chocolate Cold Foam', label: 'White Chocolate Cold Foam', price: 0.65 },
            { value: 'Dark Chocolate Cold Foam', label: 'Dark Chocolate Cold Foam', price: 0.65 }
          ]
        }
      ]
    }
  );

  addDef(
    ['Paid Whip'],
    {
      key: 'paid_whip',
      label: 'Whip',
      type: 'single',
      required: false,
      defaultValue: 'No Whip',
      options: [
        { value: 'No Whip', label: 'No Whip', price: 0, omitProperty: true },
        { value: 'Whip', label: 'Whip', price: 0.35 }
      ]
    }
  );

  addDef(
    ['Cold Foam Add-On'],
    {
      key: 'paid_cold_foam',
      label: 'Cold Foam',
      type: 'single',
      required: false,
      defaultValue: 'No Cold Foam',
      options: [
        { value: 'No Cold Foam', label: 'No Cold Foam', price: 0, omitProperty: true },
        { value: 'Vanilla Cold Foam', label: 'Vanilla Cold Foam', price: 0.50 },
        { value: 'White Chocolate Cold Foam', label: 'White Chocolate Cold Foam', price: 0.65 },
        { value: 'Dark Chocolate Cold Foam', label: 'Dark Chocolate Cold Foam', price: 0.65 }
      ]
    }
  );

  addDef(
    ['Included Cold Foam'],
    {
      key: 'included_cold_foam',
      label: 'Cold Foam',
      type: 'single',
      required: true,
      defaultValue: 'Cold Foam',
      options: [
        { value: 'Cold Foam', label: 'Cold Foam', price: 0 },
        { value: 'No Cold Foam', label: 'No Cold Foam', price: 0 }
      ]
    }
  );

  addDef(
    ['Mocha'],
    {
      key: 'included_mocha',
      label: 'Mocha',
      type: 'behavior',
      required: false
    }
  );

  addDef(
    ['Splash of Milk'],
    {
      key: 'splash_of_milk',
      label: 'Splash of Milk',
      type: 'single',
      required: false,
      defaultValue: 'No Splash',
      options: [
        { value: 'No Splash', label: 'No Splash', price: 0, omitProperty: true },
        { value: 'Regular Milk', label: 'Regular Milk', price: 0.15 },
        { value: 'Almond Milk', label: 'Almond Milk', price: 0.25 },
        { value: 'Oat Milk', label: 'Oat Milk', price: 0.25 }
      ]
    }
  );

  addDef(
    ['Milk Type'],
    {
      key: 'milk_type',
      label: 'Milk Type',
      type: 'single',
      required: true,
      defaultValue: 'Regular Milk',
      options: [
        { value: 'Regular Milk', label: 'Regular Milk', price: 0 },
        { value: 'Almond Milk', label: 'Almond Milk', price: 1.00 },
        { value: 'Oat Milk', label: 'Oat Milk', price: 1.00 }
      ]
    }
  );

  addDef(
    ['Included Whip Cream'],
    {
      key: 'included_whip',
      label: 'Whip Cream',
      type: 'single',
      required: true,
      defaultValue: 'Whip',
      options: [
        { value: 'Whip', label: 'Whip', price: 0 },
        { value: 'No Whip', label: 'No Whip', price: 0 }
      ]
    }
  );


  addDef(
    ['Refresher Flavors'],
    {
      key: 'refresher_flavor',
      label: 'Refresher Flavor',
      type: 'single',
      required: true,
      options: [
        { value: 'Strawberry Acai', label: 'Strawberry Acai', price: 0 },
        { value: 'Peach Mango', label: 'Peach Mango', price: 0 },
        { value: 'Cruel Summer', label: 'Cruel Summer', price: 0 }
      ]
    }
  );

  addDef(
    ['Milk Refreshers'],
    {
      key: 'milk_refresher',
      label: 'Creamy Refresher',
      type: 'single',
      required: true,
      options: [
        { value: 'Love Letter', label: 'Love Letter', price: 0 },
        { value: 'Strawberry Kisses', label: 'Strawberry Kisses', price: 0 }
      ]
    }
  );

  addDef(
    ['Milkshake'],
    {
      key: 'milkshake_flavor',
      label: 'Milkshake Flavor',
      type: 'single',
      required: true,
      options: [
        { value: 'Birthday Cake', label: 'Birthday Cake', price: 0 },
        { value: 'Oreos', label: 'Oreos', price: 0 },
        { value: 'Strawberry', label: 'Strawberry', price: 0 },
        { value: 'Coconut', label: 'Coconut', price: 0 },
        { value: 'Cookie Dough', label: 'Cookie Dough', price: 0 },
        { value: 'Vanilla', label: 'Vanilla', price: 0 },
        { value: 'Mango', label: 'Mango', price: 0 }
      ]
    }
  );

  addDef(
    ['Teas', 'Tea Flavors'],
    {
      key: 'tea_flavor',
      label: 'Tea Flavor',
      type: 'single',
      required: true,
      options: [
        { value: 'Peach', label: 'Peach', price: 0 },
        { value: 'Blueberry', label: 'Blueberry', price: 0 },
        { value: 'Jasmine', label: 'Jasmine', price: 0 },
        { value: 'Matcha', label: 'Matcha', price: 0 },
        { value: 'Lavender Mint', label: 'Lavender Mint', price: 0 },
        { value: 'White Orchard', label: 'White Orchard', price: 0 },
        { value: 'Camomile Citrus', label: 'Camomile Citrus', price: 0 },
        { value: 'Earl Gray', label: 'Earl Gray', price: 0 }
      ]
    }
  );

  addDef(
    ['Matcha Flavors'],
    {
      key: 'matcha_flavor',
      label: 'Matcha Flavor',
      type: 'single',
      required: true,
      options: [
        { value: 'Crazy Monkey', label: 'Crazy Monkey', price: 0 },
        { value: 'Honey Bear', label: 'Honey Bear', price: 0 },
        { value: 'Raspberry', label: 'Raspberry', price: 0 },
        { value: 'Strawberry', label: 'Strawberry', price: 0 },
        { value: 'Banana Bread', label: 'Banana Bread', price: 0 },
        { value: 'Mango Matcha', label: 'Mango Matcha', price: 0 }
      ]
    }
  );

  addDef(
    ['Additional Sauce Pumps'],
    {
      key: 'additional_pump_quantity',
      label: 'Pump Quantity',
      type: 'behavior',
      required: false
    }
  );
  function parseConfig(script) {
    try {
      const parsed = JSON.parse(script.textContent || '{}');
      return parsed && Array.isArray(parsed.sets) ? parsed : null;
    } catch (error) {
      return null;
    }
  }

  function createElement(tag, className, text) {
    const el = document.createElement(tag);
    if (className) el.className = className;
    if (typeof text === 'string') el.textContent = text;
    return el;
  }

  function priceText(price) {
    return '';
  }

  function legend(def) {
    const row = createElement('legend', 'st-native-legend');
    row.appendChild(document.createTextNode(def.label));
    if (def.required) {
      row.appendChild(createElement('span', 'st-native-required-badge', 'Required'));
    }
    return row;
  }

  function renderSingle(def, stateKey) {
    const fieldset = createElement('fieldset', 'st-native-fieldset');
    fieldset.dataset.stType = 'single';
    fieldset.dataset.stProperty = def.label;
    fieldset.dataset.stStateKey = stateKey;
    fieldset.classList.add('st-native-radio-list');
    fieldset.appendChild(legend(def));

    const grid = createElement('div', 'st-native-choice-grid');
    const name = 'st-' + stateKey + '-' + Math.random().toString(36).slice(2);

    def.options.forEach((option, index) => {
      const wrap = createElement('div', 'st-native-choice');
      const input = document.createElement('input');
      input.type = 'radio';
      input.name = name;
      input.id = name + '-' + index;
      input.value = option.value;
      input.dataset.optionPrice = typeof option.price === 'number' ? String(option.price) : '';
      input.dataset.omitProperty = option.omitProperty ? 'true' : 'false';

      if (option.value === def.defaultValue || (!def.defaultValue && index === 0 && def.required)) {
        input.checked = true;
      }

      const label = document.createElement('label');
      label.setAttribute('for', input.id);
      label.appendChild(createElement('span', '', option.label));

      const p = priceText(option.price);
      if (p) label.appendChild(createElement('span', 'st-native-option-price', p));

      wrap.appendChild(input);
      wrap.appendChild(label);
      grid.appendChild(wrap);
    });

    fieldset.appendChild(grid);
    return fieldset;
  }

  function renderMultiQty(def, stateKey) {
    const fieldset = createElement('fieldset', 'st-native-fieldset');
    fieldset.dataset.stType = 'multi_qty';
    fieldset.dataset.stProperty = def.label;
    fieldset.dataset.stStateKey = stateKey;
    fieldset.appendChild(legend(def));

    const grid = createElement('div', 'st-native-qty-grid');

    def.options.forEach((option, index) => {
      const card = createElement('div', 'st-native-qty-card');
      card.dataset.selected = 'false';
      card.dataset.optionValue = option.value;
      card.dataset.optionPrice = typeof option.price === 'number' ? String(option.price) : '';

      const head = createElement('div', 'st-native-qty-head');
      const checkbox = document.createElement('input');
      checkbox.type = 'checkbox';
      checkbox.id = 'st-' + stateKey + '-' + index + '-' + Math.random().toString(36).slice(2);
      checkbox.dataset.stQtyCheckbox = 'true';

      const copy = createElement('div', 'st-native-qty-copy');
      const optionLabel = document.createElement('label');
      optionLabel.className = 'st-native-qty-name';
      optionLabel.setAttribute('for', checkbox.id);
      optionLabel.textContent = option.label;
      copy.appendChild(optionLabel);

      const p = priceText(option.price);
      if (p) copy.appendChild(createElement('span', 'st-native-option-price', p));

      head.appendChild(checkbox);
      head.appendChild(copy);

      const stepper = createElement('div', 'st-native-stepper');
      const minus = createElement('button', '', '−');
      minus.type = 'button';
      minus.dataset.stQtyMinus = 'true';
      minus.setAttribute('aria-label', 'Decrease ' + optionLabel.textContent + ' quantity');
      minus.disabled = true;

      const output = createElement('output', '', '1');
      output.dataset.stQtyOutput = 'true';
      output.setAttribute('aria-label', optionLabel.textContent + ' quantity');

      const plus = createElement('button', '', '+');
      plus.type = 'button';
      plus.dataset.stQtyPlus = 'true';
      plus.setAttribute('aria-label', 'Increase ' + optionLabel.textContent + ' quantity');

      stepper.appendChild(minus);
      stepper.appendChild(output);
      stepper.appendChild(plus);

      card.dataset.qty = '1';
      card.dataset.max = String(option.max || 6);
      card.appendChild(head);
      card.appendChild(stepper);
      grid.appendChild(card);
    });

    fieldset.appendChild(grid);
    return fieldset;
  }

  function renderDefinition(def, sourceIndex) {
    if (def.type === 'single') {
      return [renderSingle(def, def.key + '-' + sourceIndex)];
    }

    if (def.type === 'multi_qty') {
      return [renderMultiQty(def, def.key + '-' + sourceIndex)];
    }

    if (def.type === 'compound') {
      return def.children.map((child, childIndex) =>
        child.type === 'single'
          ? renderSingle(child, def.key + '-' + sourceIndex + '-' + childIndex)
          : renderMultiQty(child, def.key + '-' + sourceIndex + '-' + childIndex)
      );
    }

    return [];
  }

  function getForm(root) {
    return root.querySelector('product-form form') || root.querySelector('form[action*="/cart/add"]');
  }

  function disableGloboFields(root) {
    root.querySelectorAll('.gpo-container input, .gpo-container select, .gpo-container textarea').forEach((field) => {
      field.disabled = true;
      field.dataset.stNativeDisabled = 'true';
    });
  }

  function getBaseQuantity(form) {
    const input = form.querySelector('[name="quantity"]');
    const value = input ? parseInt(input.value || '1', 10) : 1;
    return Number.isFinite(value) && value > 0 ? value : 1;
  }

  function collectFormProperties(form) {
    const properties = {};
    form.querySelectorAll('[name^="properties["]').forEach((field) => {
      if (field.disabled || !field.name.endsWith(']')) return;
      if ((field.type === 'checkbox' || field.type === 'radio') && !field.checked) return;
      if (!field.value) return;
      const key = field.name.slice(11, -1);
      if (key) properties[key] = field.value;
    });
    return properties;
  }

  function collectNativeCharges(nativeRoot) {
    const charges = [];
    nativeRoot.querySelectorAll('.st-native-fieldset').forEach((fieldset) => {
      const propertyName = fieldset.dataset.stProperty || 'Modifier';
      if (fieldset.dataset.stType === 'single') {
        const checked = fieldset.querySelector('input[type="radio"]:checked');
        if (!checked) return;
        const price = parseFloat(checked.dataset.optionPrice || '');
        if (Number.isFinite(price) && price > 0) charges.push({ label: propertyName + ': ' + checked.value, price: price, qty: 1 });
      }
      if (fieldset.dataset.stType === 'multi_qty') {
        fieldset.querySelectorAll('.st-native-qty-card').forEach((card) => {
          const checkbox = card.querySelector('[data-st-qty-checkbox]');
          if (!checkbox || !checkbox.checked) return;
          const price = parseFloat(card.dataset.optionPrice || '');
          if (!Number.isFinite(price) || price <= 0) return;
          charges.push({ label: propertyName + ': ' + card.dataset.optionValue, price: price, qty: Math.max(1, parseInt(card.dataset.qty || '1', 10)) });
        });
      }
    });
    return charges;
  }

  function showNativeCartError(form, message) {
    const existing = form.parentElement && form.parentElement.querySelector('[data-st-native-cart-error]');
    if (existing) existing.remove();
    const alert = document.createElement('span');
    alert.className = 'alert alert--error';
    alert.dataset.stNativeCartError = 'true';
    alert.style.marginTop = '1em';
    alert.style.display = 'block';
    alert.textContent = message || 'We could not add those customizations. Please try again.';
    if (form.parentElement) form.parentElement.appendChild(alert);
  }

  function getEditState() {
    const params = new URLSearchParams(window.location.search);
    const key = params.get('st_edit_key');
    if (!key) return null;
    let properties = {};
    try {
      properties = JSON.parse(params.get('st_edit_properties') || '{}') || {};
    } catch (error) {
      properties = {};
    }
    return {
      key: key,
      group: params.get('st_edit_group') || '',
      quantity: Math.max(1, parseInt(params.get('st_edit_quantity') || '1', 10)),
      properties: properties
    };
  }

  function restoreNativeSelections(root, nativeRoot, editState) {
    if (!editState) return;
    const form = getForm(root);
    if (!form) return;
    const quantity = form.querySelector('[name="quantity"]');
    if (quantity) quantity.value = String(editState.quantity);

    nativeRoot.querySelectorAll('.st-native-fieldset').forEach((fieldset) => {
      const stored = editState.properties[fieldset.dataset.stProperty];
      if (!stored) return;

      if (fieldset.dataset.stType === 'single') {
        const input = Array.from(fieldset.querySelectorAll('input[type="radio"]')).find((radio) =>
          stored === radio.value || stored.indexOf(radio.value + ' (+') === 0
        );
        if (input) input.checked = true;
      }

      if (fieldset.dataset.stType === 'multi_qty') {
        const entries = String(stored).split(';').map((entry) => entry.trim()).filter(Boolean);
        fieldset.querySelectorAll('.st-native-qty-card').forEach((card) => {
          const match = entries.find((entry) => entry === card.dataset.optionValue ||
            entry.indexOf(card.dataset.optionValue + ' ×') === 0 ||
            entry.indexOf(card.dataset.optionValue + ' (+') === 0);
          if (!match) return;
          const checkbox = card.querySelector('[data-st-qty-checkbox]');
          const output = card.querySelector('[data-st-qty-output]');
          const qtyMatch = match.match(/ ×(\d+)/);
          const qty = qtyMatch ? Math.max(1, parseInt(qtyMatch[1], 10)) : 1;
          if (checkbox) checkbox.checked = true;
          card.dataset.selected = 'true';
          card.dataset.qty = String(qty);
          if (output) output.textContent = String(qty);
          const minus = card.querySelector('[data-st-qty-minus]');
          if (minus) minus.disabled = false;
        });
      }
    });
  }

  function wireNativeSubmit(root, nativeRoot) {
    const form = getForm(root);
    if (!form || form.dataset.stNativeSubmitWired === 'true') return;
    form.dataset.stNativeSubmitWired = 'true';

    const editState = getEditState();
    const oldButton = form.querySelector('[type="submit"][name="add"], [data-js-product-add-to-cart]');
    if (!oldButton) return;

    const directButton = document.createElement('button');
    directButton.type = 'button';
    directButton.className = 'button button--solid button--product button--loader st-native-direct-cart';
    directButton.innerHTML = '<span class="button__text">' + (editState ? 'Save Changes' : 'Add to Cart') + '</span><span class="button__preloader"><svg class="button__preloader-element" viewBox="25 25 50 50"><circle cx="50" cy="50" r="20" fill="none" stroke-width="4"/></svg></span>';
    directButton.style.position = 'static';
    directButton.style.inset = 'auto';
    directButton.style.transform = 'none';
    directButton.style.float = 'none';
    directButton.style.margin = '0 0 0 auto';
    directButton.style.display = 'block';
    directButton.style.justifySelf = 'end';
    directButton.style.flex = '0 1 160px';
    directButton.style.width = '160px';
    directButton.style.maxWidth = '100%';
    directButton.style.minWidth = '0';
    directButton.style.minHeight = '44px';
    directButton.style.height = '44px';
    directButton.style.padding = '10px 18px';
    directButton.style.borderRadius = '999px';
    directButton.style.background = '#512c1d';
    directButton.style.borderColor = '#512c1d';
    directButton.style.color = '#ffffff';
    directButton.style.boxShadow = 'none';
    directButton.style.fontWeight = '600';

    oldButton.style.display = 'none';
    oldButton.setAttribute('aria-hidden', 'true');
    oldButton.insertAdjacentElement('afterend', directButton);

    let busy = false;

    directButton.addEventListener('click', async function(event) {
      event.preventDefault();
      event.stopPropagation();

      if (busy) return;
      busy = true;
      directButton.classList.add('working');

      try {
        updateProperties(root, nativeRoot);

        const variantInput = form.querySelector('[name="id"]');
        if (!variantInput || !variantInput.value) {
          throw new Error('Please select a drink size.');
        }

        const charges = collectNativeCharges(nativeRoot);

        const baseQuantity = getBaseQuantity(form);
        const groupId = 'st-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 8);
        const baseProperties = collectFormProperties(form);
        baseProperties._st_modifier_group = groupId;
        baseProperties._st_native_modifier = 'true';

        const items = [{
          id: Number(variantInput.value),
          quantity: baseQuantity,
          properties: baseProperties
        }];

        charges.forEach((charge) => {
          const priceKey = Number(charge.price).toFixed(2);
          const chargeVariantId = chargeVariantByPrice.get(priceKey);
          if (!chargeVariantId) {
            throw new Error('Missing internal charge for $' + priceKey + '.');
          }
          items.push({
            id: Number(chargeVariantId),
            quantity: charge.qty * baseQuantity,
            parent_id: Number(variantInput.value),
            properties: {
              _st_modifier_group: groupId,
              _st_modifier_charge: 'true',
              _st_modifier_label: charge.label,
              _st_modifier_units_per_drink: String(charge.qty)
            }
          });
        });

        const response = await fetch(KROWN.settings.routes.cart_add_url + '.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({ items: items })
        });

        let payload = null;
        try {
          payload = await response.json();
        } catch (parseError) {
          throw new Error('Shopify did not return a valid cart response.');
        }

        if (!response.ok || (payload && payload.status === 422)) {
          throw new Error(
            (payload && (payload.description || payload.message)) ||
            'Unable to add drink to cart.'
          );
        }

        if (editState) {
          const cartUrl = KROWN.settings.routes.cart_url;
          const cartHeaders = { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' };
          const getCart = async () => {
            const result = await fetch(cartUrl + '.js', { headers: cartHeaders, cache: 'no-store' });
            if (!result.ok) throw new Error('We could not verify the cart. Please review your cart before checkout.');
            return result.json();
          };
          const isOriginal = (line) => {
            const props = line.properties || {};
            // The group identifies both the original drink and its associated charge lines.
            // Never remove anything from the new group created by this save.
            return editState.group
              ? props._st_modifier_group === editState.group
              : line.key === editState.key;
          };
          const beforeRemoval = await getCart();
          const originalLines = (beforeRemoval.items || []).filter(isOriginal);
          if (!originalLines.length) {
            throw new Error('The original drink could not be found in the cart. Your new drink was added; please review your cart.');
          }

          // Delete the original group in one request. Sequential change.js calls can fail
          // when Shopify automatically removes nested charge items with their parent.
          const updates = {};
          originalLines.forEach(line => { updates[line.key] = 0; });
          const removal = await fetch(cartUrl + '/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({ updates: updates })
          });
          // Re-fetch, because Shopify may remove linked charge lines together with the parent.
          let afterRemoval = await getCart();
          let stillOriginal = (afterRemoval.items || []).filter(isOriginal);
          if (stillOriginal.length) {
            // Fallback: Shopify can re-key a nested charge line as its parent changes.
            // Remove only remaining lines in this original group using their CURRENT keys.
            const remainingUpdates = {};
            stillOriginal.forEach(line => { remainingUpdates[line.key] = 0; });
            const fallback = await fetch(cartUrl + '/update.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
              },
              body: JSON.stringify({ updates: remainingUpdates })
            });
            afterRemoval = await getCart();
            stillOriginal = (afterRemoval.items || []).filter(isOriginal);
            if (stillOriginal.length || !fallback.ok) {
              throw new Error('Your updated drink was added, but the original could not be fully removed. Please review your cart.');
            }
          }
          if (!removal.ok && stillOriginal.length) {
            throw new Error('We could not remove the original drink. Please review your cart.');
          }
        }

        window.location.assign(KROWN.settings.routes.cart_url);
      } catch (error) {
        busy = false;
        directButton.classList.remove('working');
        showNativeCartError(
          form,
          error && error.message ? error.message : 'Unable to add drink to cart.'
        );
      }
    });
  }

  function updateProperties(root, nativeRoot) {
    const form = getForm(root);
    if (!form) return;

    form.querySelectorAll('[data-st-native-property]').forEach((input) => input.remove());

    const nativeMarker = document.createElement('input');
    nativeMarker.type = 'hidden';
    nativeMarker.name = 'properties[_st_native_modifier]';
    nativeMarker.value = 'true';
    nativeMarker.dataset.stNativeProperty = 'true';
    form.appendChild(nativeMarker);

    nativeRoot.querySelectorAll('.st-native-fieldset').forEach((fieldset) => {
      const propertyName = fieldset.dataset.stProperty;
      const type = fieldset.dataset.stType;
      let value = '';

      if (type === 'single') {
        const checked = fieldset.querySelector('input[type="radio"]:checked');
        if (checked && checked.dataset.omitProperty !== 'true') {
          const price = parseFloat(checked.dataset.optionPrice || '');
          value = checked.value;
          if (Number.isFinite(price) && price > 0) {
            value += ' (+' + money(price) + ')';
          }
        }
      }

      if (type === 'multi_qty') {
        const selected = [];
        fieldset.querySelectorAll('.st-native-qty-card').forEach((card) => {
          const checkbox = card.querySelector('[data-st-qty-checkbox]');
          if (!checkbox || !checkbox.checked) return;
          const qty = Math.max(1, parseInt(card.dataset.qty || '1', 10));
          const price = parseFloat(card.dataset.optionPrice || '');
          let itemValue = card.dataset.optionValue + (qty > 1 ? ' ×' + qty : '');
          if (Number.isFinite(price) && price > 0) {
            itemValue += ' (+' + money(price * qty) + ')';
          }
          selected.push(itemValue);
        });
        value = selected.join('; ');
      }

      if (!value) return;

      const hidden = document.createElement('input');
      hidden.type = 'hidden';
      hidden.name = 'properties[' + propertyName + ']';
      hidden.value = value;
      hidden.dataset.stNativeProperty = 'true';
      form.appendChild(hidden);
    });
  }

  function selectedOptionalTotal(nativeRoot) {
    let total = 0;

    nativeRoot.querySelectorAll('.st-native-optional .st-native-fieldset').forEach((fieldset) => {
      if (fieldset.dataset.stType === 'single') {
        const checked = fieldset.querySelector('input[type="radio"]:checked');
        if (!checked) return;
        const price = parseFloat(checked.dataset.optionPrice || '');
        if (Number.isFinite(price)) total += price;
      }

      if (fieldset.dataset.stType === 'multi_qty') {
        fieldset.querySelectorAll('.st-native-qty-card').forEach((card) => {
          const checkbox = card.querySelector('[data-st-qty-checkbox]');
          if (!checkbox || !checkbox.checked) return;
          const price = parseFloat(card.dataset.optionPrice || '');
          const qty = Math.max(1, parseInt(card.dataset.qty || '1', 10));
          if (Number.isFinite(price)) total += price * qty;
        });
      }
    });

    return total;
  }

  function updateCustomizeTotal(nativeRoot) {
    const totalEl = nativeRoot.querySelector('.st-native-customize-total');
    if (!totalEl) return;
    totalEl.textContent = '';
  }

  function wireEvents(root, nativeRoot) {
    nativeRoot.addEventListener('change', (event) => {
      const checkbox = event.target.closest('[data-st-qty-checkbox]');
      if (checkbox) {
        const card = checkbox.closest('.st-native-qty-card');
        card.dataset.selected = checkbox.checked ? 'true' : 'false';
        const minus = card.querySelector('[data-st-qty-minus]');
        if (minus) minus.disabled = !checkbox.checked;
      }

      updateProperties(root, nativeRoot);
      updateCustomizeTotal(nativeRoot);
    });

    nativeRoot.addEventListener('click', (event) => {
      const plus = event.target.closest('[data-st-qty-plus]');
      const minus = event.target.closest('[data-st-qty-minus]');
      if (!plus && !minus) return;

      event.preventDefault();

      const card = event.target.closest('.st-native-qty-card');
      if (!card) return;

      const checkbox = card.querySelector('[data-st-qty-checkbox]');
      const output = card.querySelector('[data-st-qty-output]');
      const max = Math.max(1, parseInt(card.dataset.max || '6', 10));
      let qty = Math.max(1, parseInt(card.dataset.qty || '1', 10));

      if (plus) {
        if (!checkbox.checked) {
          checkbox.checked = true;
          card.dataset.selected = 'true';
        } else {
          qty = Math.min(max, qty + 1);
        }
      }

      if (minus && checkbox.checked) {
        if (qty <= 1) {
          checkbox.checked = false;
          card.dataset.selected = 'false';
          qty = 1;
        } else {
          qty -= 1;
        }
      }

      card.dataset.qty = String(qty);
      output.textContent = String(qty);

      const minusButton = card.querySelector('[data-st-qty-minus]');
      if (minusButton) minusButton.disabled = !checkbox.checked;

      updateProperties(root, nativeRoot);
      updateCustomizeTotal(nativeRoot);
    });
  }

  function build(script) {
    const config = parseConfig(script) || (script.dataset.productHandle === 'flavored-steamers' ? { sets: [] } : null);
    if (!config) return;

    const sectionId = script.dataset.sectionId;
    const root = document.getElementById('product-' + sectionId);
    if (!root || root.dataset.stNativeModifiersBuilt === 'true') return;
    root.classList.add('st-drink-product');

    const draftSetOverrides = {
      'london-fog-latte': [
        'Extra Tea Bag',
        'Additional  Espresso Shots - ZJ23FLQADUCJ6LYEZHWHIY2B',
        'Additional  Espresso Shots - QEJICJ2BCPUEY463XFBQPP62',
        'Additional Add on Sauce',
        'Additional Add on Syrups',
        'Milk Type'
      ],
      'iced-london-fog': [
        'Extra Tea Bag',
        'Additional  Espresso Shots - ZJ23FLQADUCJ6LYEZHWHIY2B',
        'Additional  Espresso Shots - QEJICJ2BCPUEY463XFBQPP62',
        'Additional Add on Sauce',
        'Additional Add on Syrups',
        'Additional Sauce Pumps',
        'Extras Whip/Cold Foam',
        'Milk Type'
      ],
      'hot-sweet-matcha': [
        'Additional  Espresso Shots - ZJ23FLQADUCJ6LYEZHWHIY2B',
        'Additional Add on Syrups',
        'Additional Add on Sauce',
        'Extra Sauce Drizzle',
        'Included  Syrup Selection',
        'Milk Type'
      ],
      'iced-sweet-matcha': [
        'Additional  Espresso Shots - ZJ23FLQADUCJ6LYEZHWHIY2B',
        'Additional Add on Syrups',
        'Additional Add on Sauce',
        'Extra Sauce Drizzle',
        'Milk Type'
      ],
      'iced-mango-matcha': [
        'Additional  Espresso Shots - ZJ23FLQADUCJ6LYEZHWHIY2B',
        'Additional Add on Syrups',
        'Additional Add on Sauce',
        'Extra Sauce Drizzle',
        'Milk Type'
      ],
      'iced-raspberry-matcha': [
        'Additional  Espresso Shots - ZJ23FLQADUCJ6LYEZHWHIY2B',
        'Additional Add on Syrups',
        'Additional Add on Sauce',
        'Extra Sauce Drizzle',
        'Milk Type'
      ],
      'iced-strawberry-matcha': [
        'Additional  Espresso Shots - ZJ23FLQADUCJ6LYEZHWHIY2B',
        'Additional Add on Syrups',
        'Additional Add on Sauce',
        'Extra Sauce Drizzle',
        'Extras Whip/Cold Foam',
        'Milk Type'
      ],
      'pistachio-cloud-matcha': [
        'Additional  Espresso Shots - ZJ23FLQADUCJ6LYEZHWHIY2B',
        'Additional Add on Syrups',
        'Additional Add on Sauce',
        'Extra Sauce Drizzle',
        'Milk Type'
      ],
      'flavored-steamers': [
        'Additional Add on Syrups',
        'Coffee',
        'Extra Sauce Drizzle'
      ],
      'butter-me-pecan': [
        'Additional  Espresso Shots - ZJ23FLQADUCJ6LYEZHWHIY2B',
        'Additional  Espresso Shots - QEJICJ2BCPUEY463XFBQPP62',
        'Additional Add on Sauce',
        'Additional Add on Syrups',
        'Coffee',
        'Extra Sauce Drizzle',
        'Included Whip Cream',
        'Milk Type'
      ],
      'biscoff-cookie-butter': [
        'Additional  Espresso Shots - ZJ23FLQADUCJ6LYEZHWHIY2B',
        'Additional  Espresso Shots - QEJICJ2BCPUEY463XFBQPP62',
        'Additional Add on Sauce',
        'Additional Add on Syrups',
        'Coffee',
        'Extra Sauce Drizzle',
        'Included Whip Cream',
        'Milk Type'
      ],
      'iced-biscoff-cookie-butter': [
        'Additional  Espresso Shots - ZJ23FLQADUCJ6LYEZHWHIY2B',
        'Additional  Espresso Shots - QEJICJ2BCPUEY463XFBQPP62',
        'Additional Add on Sauce',
        'Additional Add on Syrups',
        'Coffee',
        'Extra Sauce Drizzle',
        'Included Cold Foam',
        'Milk Type'
      ],
      'iced-cinnabun-latte': [
        'Additional  Espresso Shots - ZJ23FLQADUCJ6LYEZHWHIY2B',
        'Additional  Espresso Shots - QEJICJ2BCPUEY463XFBQPP62',
        'Additional Add on Sauce',
        'Additional Add on Syrups',
        'Additional Sauce Pumps',
        'Coffee',
        'Extra Sauce Drizzle',
        'Included Cold Foam',
        'Milk Type'
      ],
      'peppermint-mocha': [
        'Additional  Espresso Shots - ZJ23FLQADUCJ6LYEZHWHIY2B',
        'Additional  Espresso Shots - QEJICJ2BCPUEY463XFBQPP62',
        'Additional Add on Syrups',
        'Additional Sauce Pumps',
        'Coffee',
        'Extra Sauce Drizzle',
        'Extras Whip/Cold Foam',
        'Milk Type',
        'Mocha'
      ],
      'iced-peppermint-mocha': [
        'Additional  Espresso Shots - ZJ23FLQADUCJ6LYEZHWHIY2B',
        'Additional  Espresso Shots - QEJICJ2BCPUEY463XFBQPP62',
        'Additional Add on Syrups',
        'Additional Sauce Pumps',
        'Coffee',
        'Extra Sauce Drizzle',
        'Included Cold Foam',
        'Milk Type',
        'Mocha'
      ],
      'pistachio-mocha': [
        'Additional  Espresso Shots - ZJ23FLQADUCJ6LYEZHWHIY2B',
        'Additional  Espresso Shots - QEJICJ2BCPUEY463XFBQPP62',
        'Additional Add on Sauce',
        'Additional Add on Syrups',
        'Additional Sauce Pumps',
        'Coffee',
        'Extra Sauce Drizzle',
        'Extras Whip/Cold Foam',
        'Milk Type'
      ],
      'iced-pistachio-mocha': [
        'Additional  Espresso Shots - ZJ23FLQADUCJ6LYEZHWHIY2B',
        'Additional  Espresso Shots - QEJICJ2BCPUEY463XFBQPP62',
        'Additional Add on Sauce',
        'Additional Add on Syrups',
        'Additional Sauce Pumps',
        'Coffee',
        'Extra Sauce Drizzle',
        'Included Cold Foam',
        'Milk Type'
      ],
      'pumpkin-spice-white-chocolate': [
        'Additional  Espresso Shots - ZJ23FLQADUCJ6LYEZHWHIY2B',
        'Additional  Espresso Shots - QEJICJ2BCPUEY463XFBQPP62',
        'Additional Add on Sauce',
        'Additional Add on Syrups',
        'Additional Sauce Pumps',
        'Coffee',
        'Extra Sauce Drizzle',
        'Extras Whip/Cold Foam',
        'Milk Type'
      ],
      'iced-pumpkin-spice-white-chocolate': [
        'Additional  Espresso Shots - ZJ23FLQADUCJ6LYEZHWHIY2B',
        'Additional  Espresso Shots - QEJICJ2BCPUEY463XFBQPP62',
        'Additional Add on Sauce',
        'Additional Add on Syrups',
        'Additional Sauce Pumps',
        'Coffee',
        'Extra Sauce Drizzle',
        'Included Cold Foam',
        'Milk Type'
      ]
    };
    const productHandle = script.dataset.productHandle;
    const isMatchaProduct = productHandle.includes('matcha');
    const removeIncludedSyrupFlavor = ['white-mocha', 'iced-white-mocha', 'butter-me-pecan', 'iced-butter-me-pecan', 'hot-sweet-matcha'].includes(productHandle);
    const removeCoffeeRoast = productHandle === 'hot-chocolate';
    const hotDrinkHandles = [
        'almond-joy-1',
        'americano',
        'biscoff-cookie-butter',
        'butter-me-pecan',
        'caramel-macchiato-1',
        'chai-latte',
        'dark-mocha',
        'espresso-shots',
        'flavored-latte',
        'flavored-steamers',
        'hot-chocolate',
        'hot-sweet-matcha',
        'hot-unsweetened-tea',
        'latte',
        'london-fog-latte',
        'peppermint-mocha',
        'pistachio-mocha',
        'pumpkin-spice-white-chocolate',
        'raspberry-white-mocha',
        'turtle-mocha',
        'white-mocha'
    ];
    const hotPaidWhipHandles = [
        'almond-joy-1',
        'americano',
        'caramel-macchiato-1',
        'dark-mocha',
        'espresso-shots',
        'flavored-latte',
        'flavored-steamers',
        'hot-chocolate',
        'hot-sweet-matcha',
        'latte',
        'peppermint-mocha',
        'pistachio-mocha',
        'pumpkin-spice-white-chocolate',
        'raspberry-white-mocha',
        'turtle-mocha',
        'white-mocha'
    ];
    const assigned = (draftSetOverrides[productHandle] || config.sets || []).filter((setName) =>
      !(removeIncludedSyrupFlavor && normalize(setName) === normalize('Included  Syrup Selection')) &&
      !(removeCoffeeRoast && normalize(setName) === normalize('Coffee')) &&
      !(hotDrinkHandles.includes(productHandle) && normalize(setName).includes('cold foam'))
    );
    if (
      script.dataset.productHandle === 'cold-brew' &&
      !assigned.some((setName) => normalize(setName).includes('additional espresso shots'))
    ) {
      assigned.push('Additional  Espresso Shots - ZJ23FLQADUCJ6LYEZHWHIY2B');
    }
    if (
      ['unsweetened-iced-tea', 'hot-unsweetened-tea'].includes(productHandle) &&
      !assigned.some((setName) => normalize(setName) === normalize('Extra Tea Bag'))
    ) {
      assigned.unshift('Extra Tea Bag');
    }
    if (
      hotPaidWhipHandles.includes(productHandle) &&
      !assigned.some((setName) => normalize(setName) === normalize('Paid Whip'))
    ) {
      assigned.push('Paid Whip');
    }

    const freeFlavorSets = new Set([
      normalize('Included  Syrup Selection'),
      normalize('Matcha Flavors'),
      normalize('Refresher Flavors'),
      normalize('Milk Refreshers'),
      normalize('Milkshake'),
      normalize('Tea Flavors'),
      normalize('Teas'),
      normalize('The Shaken Flavors')
    ]);

    const includedFoamSets = new Set([
      normalize('Included Cold Foam'),
      normalize('Included Whip Cream')
    ]);

    const mappedRaw = assigned.map((setName, index) => ({
      setName,
      index,
      normalized: normalize(setName),
      def: defs.get(normalize(setName))
    }));

    const unsupported = mappedRaw.filter((item) => !item.def);
    if (unsupported.length) {
      root.dataset.stNativeModifiersStatus = 'waiting-for-definitions';
      root.dataset.stNativeUnsupportedSets = unsupported.map((item) => item.setName).join(' | ');
      return;
    }

    if (!mappedRaw.length) return;

    const hasIncludedFoam = mappedRaw.some((item) => includedFoamSets.has(item.normalized));

    function semanticKey(item) {
      if (item.normalized.includes('additional espresso shots')) return 'extra-espresso';
      return item.normalized;
    }

    function primaryPriority(item) {
      const n = item.normalized;
      if (n === normalize('Coffee')) return 10;
      if (n === normalize('Milk Type')) return 20;
      if (n === normalize('Splash of Milk')) return 25;
      if (freeFlavorSets.has(n)) return 30;
      if (n === normalize('Extra Tea Bag')) return 35;
      if (n.includes('additional espresso shots')) return 40;
      if (n === normalize('Paid Whip')) return 45;
      if (includedFoamSets.has(n)) return 50;
      if (n === normalize('Extras Whip/Cold Foam') && !isMatchaProduct && !hasIncludedFoam) return 50;
      return 1000;
    }

    function customizationPriority(item) {
      const n = item.normalized;
      if (n === normalize('Additional Add on Syrups')) return 110;
      if (n === normalize('Additional Add on Sauce')) return 120;
      if (n === normalize('Extra Sauce Drizzle')) return 130;
      if (n === normalize('Select Syrups below')) return 140;
      if (n === normalize('Select Sauce Below')) return 150;
      if (n === normalize('Additional Sauce Pumps')) return 160;
      if (n === normalize('Select syrup pumps')) return 170;
      if (n === normalize('Extras Whip/Cold Foam')) return 180;
      return 500;
    }

    function isPrimary(item) {
      return primaryPriority(item) < 1000;
    }

    const seen = new Set();
    const mapped = mappedRaw.filter((item) => {
      const key = semanticKey(item);
      if (seen.has(key)) return false;
      seen.add(key);
      return true;
    });

    const primaryItems = mapped
      .filter(isPrimary)
      .sort((a, b) => primaryPriority(a) - primaryPriority(b) || a.index - b.index);

    const customizationItems = mapped
      .filter((item) => !isPrimary(item))
      .sort((a, b) => customizationPriority(a) - customizationPriority(b) || a.index - b.index);

    const form = getForm(root);
    const cartFunctions = root.querySelector('.product__cart-functions');
    if (!form || !cartFunctions) return;

    const nativeRoot = createElement('div', 'st-native-modifiers');
    nativeRoot.dataset.stNativeModifiers = 'true';

    const required = createElement('div', 'st-native-required');
    const optional = createElement('div', 'st-native-optional');

    primaryItems.forEach((item) => {
      renderDefinition(item.def, item.index).forEach((node) => required.appendChild(node));
    });

    customizationItems.forEach((item) => {
      renderDefinition(item.def, item.index).forEach((node) => optional.appendChild(node));
    });

    if (required.childElementCount) nativeRoot.appendChild(required);

    if (optional.childElementCount) {
      const details = createElement('details', 'st-native-customize');

      const summary = document.createElement('summary');
      summary.innerHTML = `
        <span class="st-native-customize-icon" aria-hidden="true">+</span>
        <span class="st-native-customize-copy">
          <span class="st-native-customize-title">Customize It!</span>
          <span class="st-native-customize-subtitle">Add your special touch</span>
        </span>
        <span class="st-native-customize-total" aria-live="polite"></span>
        <span class="st-native-customize-arrow" aria-hidden="true"></span>
      `;

      details.appendChild(summary);
      details.appendChild(optional);
      nativeRoot.appendChild(details);
    }

    cartFunctions.parentNode.insertBefore(nativeRoot, cartFunctions);

    root.classList.add('st-native-modifiers-ready');
    disableGloboFields(root);
    root.dataset.stNativeModifiersBuilt = 'true';
    root.dataset.stNativeModifiersStatus = 'ready';

    wireEvents(root, nativeRoot);
    restoreNativeSelections(root, nativeRoot, getEditState());
    wireNativeSubmit(root, nativeRoot);
    updateProperties(root, nativeRoot);
    updateCustomizeTotal(nativeRoot);
  }

  function boot() {
    mergeAppPrices();
    document.querySelectorAll('[data-st-drink-modifier-config]').forEach((script) => {
      build(script);

      const sectionId = script.dataset.sectionId;
      const root = document.getElementById('product-' + sectionId);
      if (!root || root.dataset.stNativeModifiersBuilt === 'true') return;

      let attempts = 0;
      const timer = window.setInterval(() => {
        attempts += 1;
        build(script);
        if (root.dataset.stNativeModifiersBuilt === 'true' || attempts >= 30) {
          window.clearInterval(timer);
        }
      }, 150);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();

